import React from 'react';
import './ConfirmModal.css';

/**
 * ConfirmModal - Genel onay modalı komponenti
 * 
 * @param {boolean} isOpen - Modal açık mı?
 * @param {function} onClose - Modal kapatma fonksiyonu
 * @param {function} onConfirm - Onay butonu fonksiyonu
 * @param {string} title - Modal başlığı
 * @param {string} message - Ana mesaj
 * @param {string} warningText - Uyarı metni (opsiyonel)
 * @param {string} confirmText - Onay butonu metni (varsayılan: "Evet")
 * @param {string} cancelText - İptal butonu metni (varsayılan: "İptal")
 * @param {string} variant - Stil tipi: "danger", "warning", "success", "default"
 * @param {boolean} loading - Yükleniyor durumu
 * @param {string} icon - Başlık ikonu (opsiyonel)
 */
function ConfirmModal({
    isOpen,
    onClose,
    onConfirm,
    title = 'Emin misiniz?',
    message = 'Bu işlemi gerçekleştirmek istediğinizden emin misiniz?',
    warningText = '',
    confirmText = 'Evet',
    cancelText = 'İptal',
    variant = 'default', // danger, warning, success, default
    loading = false,
    icon = '⚠️'
}) {
    if (!isOpen) return null;

    const handleBackdropClick = (e) => {
        if (e.target === e.currentTarget && !loading) {
            onClose();
        }
    };

    const handleConfirm = () => {
        if (!loading && onConfirm) {
            onConfirm();
        }
    };

    const getWarningIcon = () => {
        switch (variant) {
            case 'danger':
                return '🚨';
            case 'warning':
                return '⚠️';
            case 'success':
                return '✅';
            default:
                return '💡';
        }
    };

    return (
        <div className="confirm-modal-backdrop" onClick={handleBackdropClick}>
            <div className={`confirm-modal-content ${variant}`} onClick={e => e.stopPropagation()}>
                <div className="confirm-modal-header">
                    <h3>
                        {icon && <span>{icon}</span>}
                        {title}
                    </h3>
                    <button 
                        className="confirm-modal-close" 
                        onClick={onClose}
                        disabled={loading}
                    >
                        ✕
                    </button>
                </div>

                <div className="confirm-modal-body">
                    <p className="confirm-modal-message">{message}</p>
                    
                    {warningText && (
                        <div className="confirm-modal-warning">
                            <span className="confirm-modal-warning-icon">
                                {getWarningIcon()}
                            </span>
                            <span className="confirm-modal-warning-text">
                                {warningText}
                            </span>
                        </div>
                    )}
                </div>

                <div className="confirm-modal-footer">
                    <button
                        className="confirm-modal-btn confirm-modal-btn-cancel"
                        onClick={onClose}
                        disabled={loading}
                    >
                        {cancelText}
                    </button>
                    <button
                        className={`confirm-modal-btn confirm-modal-btn-confirm ${variant} ${loading ? 'confirm-modal-btn-loading' : ''}`}
                        onClick={handleConfirm}
                        disabled={loading}
                    >
                        {confirmText}
                    </button>
                </div>
            </div>
        </div>
    );
}

export default ConfirmModal;